import script from "./finalInspection.vue?vue&type=script&setup=true&lang=ts"
export * from "./finalInspection.vue?vue&type=script&setup=true&lang=ts"

import "./finalInspection.vue?vue&type=style&index=0&id=10f89cc9&scoped=true&lang=css"
import "./finalInspection.vue?vue&type=style&index=1&id=10f89cc9&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10f89cc9"]])

export default __exports__